<template>
	<sf-data-table ref="grpTable" index :paging="false" :excel="isButton_(scrId, 'EX')" :columns="cols" :rows="rows" :stripe="false" :selection="false" :span-method="spanMethod"> </sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcClmTop/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		}
		,spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 5) {
				if (rowIndex % 100000 === 0) {
					return {
						rowspan: 100000,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
				
			}
		}
	}
};
</script>

<style></style>
